import MojitoCore from 'mojito/core';

export default class Renderable extends MojitoCore.Presentation.UIViewImplementation {
    render() {
        const { content, context, args } = this.props;
        return content.apply(context, args);
    }
}
